import React from 'react'
import styles from './BookingSection.module.css'

const FEATURES = [
  {
    icon: '🔬',
    title: 'Dr Lal PathLabs Network',
    desc: 'Authorized sample intake center with gold-standard diagnostic precision.',
  },
  {
    icon: '⚡',
    title: 'Express Counter Fast-Track',
    desc: 'Skip long waiting queues with your pre-booked appointment ID.',
  },
  {
    icon: '📱',
    title: 'Digital Reports in 24h',
    desc: 'Direct PDF delivery to your phone via SMS, WhatsApp & Email.',
  },
  {
    icon: '🛡️',
    title: 'NABL & ISO Accredited',
    desc: 'Certified phlebotomists adhering to 100% sterile safety protocols.',
  },
]

export const TrustFeatures: React.FC = () => {
  return (
    <aside className={styles.trustSidebar} aria-label="Why book with us">
      <div className={styles.trustHeader}>
        <span className={styles.trustBadge}>WHY CHOOSE US</span>
        <h3 className={styles.trustTitle}>Trusted Pathology Services at Your Doorstep</h3>
        <p className={styles.trustSubtitle}>
          Nextgen Health Care is an authorized collection center partner of Dr Lal PathLabs Ltd.
        </p>
      </div>

      <div className={styles.featuresList}>
        {FEATURES.map((item, idx) => (
          <div key={idx} className={styles.featureItem}>
            <div className={styles.featureIcon} aria-hidden="true">{item.icon}</div>
            <div className={styles.featureContent}>
              <h4 className={styles.featureTitle}>{item.title}</h4>
              <p className={styles.featureDesc}>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.supportBox}>
        <div className={styles.supportIcon} aria-hidden="true">📞</div>
        <div>
          <span className={styles.supportLabel}>Need assistance?</span>
          <p className={styles.supportPhone}>Call Helpline: 011-4988-5050</p>
        </div>
      </div>
    </aside>
  )
}

